import React from 'react'
import YouTube, { YouTubeProps } from 'react-youtube'
import { useMediaQuery } from 'react-responsive'
import theme from '@/components/themes/mainTheme'

interface IProps {
  id: string
}

const YoutubePlayer: React.FC<IProps> = ({ id }) => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.values.md}px)`,
  })

  const opts: YouTubeProps['opts'] = {
    width: isMobile ? '380' : '640',
    height: isMobile ? '228' : '385',
    playerVars: {
      autoplay: 0,
      rel: 0,
    },
  }

  return <YouTube videoId={id} opts={opts} />
}

export default YoutubePlayer
